import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common"

const formField={
    skuCode: {
        name: "skuCode",
        label: "SKU Code",
        type: "select",
        errorMsg: "SKU Code is required.",
        required:true,
        editable:false
    },
    customerCode: {
        name: "customerCode",
        label: "Customer Code",
        type: "text",
        errorMsg: "Customer Code is required.",
        required:true,
        disabled:true
    },
    vendorCode: {
        name: "vendorCode",
        label: "Vendor Code",
        type: "select",
        errorMsg: "Vendor Code is required.",
        required:true,
        editable:false
    },
    packType: {
        name: "packType",
        label: "Pack Type",
        type: "text",
        errorMsg: "Pack Type is required.",
        required:true,
        editable:false
    },
    description: {
        name: "description",
        label: "Description",
        type: "text",
    },
    baseUOM: {
        name: "baseUOM",
        label: "Base UOM",
        type: "select",
        errorMsg: "Base UOM is required.",
        required:true
    },
    upmBase: {
        name: "upmBase",
        label: "UPM Base (e.g. L.UOM)",
        type: "number",
        errorMsg: "UPM Base is required.",
        required:true,
        disabled:true
    },
    innerpackUOM: {
        name: "innerpackUOM",
        label: "Innerpack UOM",
        type: "select",
    },
    upmInnerpack: {
        name: "upmInnerpack",
        label: "UPM Innerpack (e.g. EA/BOX)",
        type: "number",
    },
    caseUOM: {
        name: "caseUOM",
        label: "Case UOM",
        type: "select",
    },
    upmCase: {
        name: "upmCase",
        label: "UPM Case (e.g. EA/CTN)",
        type: "number",
    },
    palletUOM: {
        name: "palletUOM",
        label: "Pallet UOM",
        type: "select",
        errorMsg: "Pallet UOM is required.",
        required:true,
    },
    upmPallet: {
        name: "upmPallet",
        label: "UPM Pallet (e.g. EA/PLT)",
        type: "number",
        errorMsg: "UPM Pallet is required.",
        required:true
    },
    palletType: {
        name: "palletType",
        label: "Pallet Type",
        type: "select",
        required:true,
    },
    grossWeightUOM: {
        name: "grossWeightUOM",
        label: "Gross Weight UOM",
        type: "select",
    },
    upmGrossWeight: {
        name: "upmGrossWeight",
        label: "UPM Gross Weight (e.g. KG/EA)",
        type: "number",
    },
    netWeightUOM: {
        name: "netWeightUOM",
        label: "Carton Weight UOM",
        type: "select",
    },
    upmNetWeight: {
        name: "upmNetWeight",
        label: "UPM Carton Weight (e.g. KG/EA)",
        type: "number",
    },
    cubicUOM: {
        name: "cubicUOM",
        label: "Cubic UOM",
        type: "select",
    },
    upmCubic: {
        name: "upmCubic",
        label: "UPM Cubic (e.g. M3/EA)",
        type: "number",
    },
    cubicHeight: {
        name: "cubicHeight",
        label: "Cubic Height",
        type: "number",
    },
    cubicWidth: {
        name: "cubicWidth",
        label: "Cubic Width",
        type: "number",
    },
    cubicDepth: {
        name: "cubicDepth",
        label: "Cubic Depth",
        type: "number",
    },
    nestedHeight: {
        name: "nestedHeight",
        label: "Nested Height",
        type: "number",
    },
}
 

const {
     skuCode, customerCode, vendorCode, packType, description, baseUOM, upmBase, innerpackUOM, upmInnerpack, caseUOM, upmCase, palletUOM, upmPallet, palletType, grossWeightUOM, upmGrossWeight, netWeightUOM, upmNetWeight, cubicUOM, upmCubic, cubicHeight, cubicWidth, cubicDepth, nestedHeight 
} = formField;

export const form = {
    formId: "add-sku-pack-type-form",
    formField,
    formRender:[
        [skuCode,customerCode],
        [vendorCode,packType],
        [description],
        [{type:"title",label:"Base Measurement"}],
        [upmBase,baseUOM],
        [{type:"title",label:"Inner Pack Measurement"}],
        [upmInnerpack,innerpackUOM],
        [{type:"title",label:"Case Measurement"}],
        [upmCase,caseUOM],
        [{type:"title",label:"Pallet Measurement"}],
        [upmPallet,palletUOM],
        [palletType],
        [{type:"title",label:"Weight Measurement"}],
        [upmGrossWeight,grossWeightUOM],
        [upmNetWeight,netWeightUOM],
        [{type:"title",label:"Cubic Measurement"}],
        [upmCubic,cubicUOM],
        [cubicHeight,cubicDepth],
        [cubicWidth,nestedHeight]
    ]
};

export const formRender=[
    [skuCode,packType,vendorCode,customerCode],
    [description],
    [{type:"title",label:"Base Measurement"},"",{type:"title",label:"Inner Pack Measurement"}],
    [upmBase,baseUOM,upmInnerpack,innerpackUOM],
    [{type:"title",label:"Case Measurement"},"",{type:"title",label:"Pallet Measurement"}],
    [upmCase,caseUOM,upmPallet,palletUOM],
    ["","",palletType ],
    [{type:"title",label:"Weight Measurement"}],
    [upmGrossWeight,grossWeightUOM,upmNetWeight,netWeightUOM], 
    [{type:"title",label:"Cubic Measurement"}],
    [upmCubic,cubicUOM],
    [cubicHeight,cubicDepth,cubicWidth,nestedHeight],
]

export const initialValues = getInitialValues(formField);

export const skuPackTypeValidation = Yup.object().shape({
    //required
    [skuCode.name]: Yup.string().nullable().max(50).required(skuCode.errorMsg),
    [customerCode.name]: Yup.string().nullable().max(20).required(customerCode.errorMsg),
    [vendorCode.name]: Yup.string().nullable().max(20).required(vendorCode.errorMsg),
    [packType.name]: Yup.string().nullable().max(10).required(packType.errorMsg),
    [description.name]: Yup.string().nullable().max(100),
    [baseUOM.name]: Yup.string().nullable().max(10).required(baseUOM.errorMsg),
    [innerpackUOM.name]: Yup.string().nullable().max(10),
    [caseUOM.name]: Yup.string().nullable().max(10),
    [palletUOM.name]: Yup.string().nullable().max(10).required(palletUOM.errorMsg),
    // [palletType.name]: Yup.string().max(20).required(palletType.errorMsg),
    [palletType.name]:Yup.object().shape({
        "label":Yup.string(),"value":Yup.string()
    }).nullable().required(),
    [grossWeightUOM.name]: Yup.string().nullable().max(10),
    [netWeightUOM.name]: Yup.string().nullable().max(10),
    //number
    [upmBase.name]:Yup.number().min(1).required(upmBase.errorMsg),
    [upmInnerpack.name]:Yup.number().min(0),
    [upmCase.name]:Yup.number().min(0),
    [upmPallet.name]:Yup.number().min(1).required(upmPallet.errorMsg),
    [upmGrossWeight.name]:Yup.number().min(0),
    [upmNetWeight.name]:Yup.number().min(0),
    [cubicHeight.name]:Yup.number().min(0),
    [cubicDepth.name]:Yup.number().min(0),
    [cubicWidth.name]:Yup.number().min(0),
    [nestedHeight.name]:Yup.number().min(0)
})